<template>
  <div class="single-select-dropdown">
    <select v-model="selectedValue" @change="handleChange">
      <option disabled value="">{{ placeholder }}</option>
      <option v-for="option in options" :key="option.value" :value="option.value">
        {{ option.label }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: "Select an option",
    },
  },
  data() {
    return {
      selectedValue: this.value,
    };
  },
  watch: {
    value(newVal) {
      this.selectedValue = newVal;
    },
  },
  methods: {
    handleChange() {
      this.$emit("input", this.selectedValue);
    },
  },
};
</script>

<style scoped>
.single-select-dropdown {
  /* Add your styling here */
}
</style>
